import { saleApi } from '@/app/api/saleApi';

export interface PublicDeliveryConfig {
  enabled: boolean;
  zone_mode?: 'DISTANCE' | 'CITY';
  travel_mode: 'DRIVING' | 'WALKING' | 'BICYCLING';
  max_distance_km: string;
  min_order_ttc: string;
  tiers: { from_km: string; to_km: string; fee_ttc: string; min_order_ttc?: string | null }[];
  cities?: {
    name: string;
    postcode?: string;
    fee_ttc: string;
    min_order_ttc?: string | null;
    // SC-1168 : vide pour une commune, nom de la commune pour un secteur (absent : ancien backend).
    parent_city?: string;
  }[];
}

export interface Destination {
  place_id: string;
  lat: number;
  lng: number;
  formatted_address: string;
}

export type QuoteResponse =
  | {
      ok: true;
      distance_km?: string;
      duration_min?: number;
      travel_mode?: 'DRIVING' | 'WALKING' | 'BICYCLING';
      tier_id?: number;
      city?: string;
      // SC-1168 : nom du secteur quand le devis tombe dans un hameau ; `city` reste la commune.
      sector?: string;
      fee_ttc: string;
      min_order_ttc?: string;
      computed_at: string;
    }
  | {
      ok: false;
      reason:
        | 'DELIVERY_DISABLED'
        | 'OUT_OF_RANGE'
        | 'CITY_NOT_SERVED'
        | 'GEOCODE_FAILED'
        | 'ROUTES_API_ERROR';
      city?: string;
      sector?: string;
      distance_km?: string;
      max_distance_km?: string;
    };

export const deliveryApi = saleApi.injectEndpoints({
  endpoints: (build) => ({
    getDeliveryConfig: build.query<PublicDeliveryConfig, string>({
      query: (restaurantUuid) => `/sale/order/delivery/public/${restaurantUuid}/`,
    }),
    fetchDeliveryQuote: build.mutation<
      QuoteResponse,
      { restaurantUuid: string; destination: Destination }
    >({
      query: ({ restaurantUuid, destination }) => ({
        url: '/sale/order/delivery/quote/',
        method: 'POST',
        body: { restaurant_uuid: restaurantUuid, destination },
      }),
    }),
  }),
  overrideExisting: false,
});

export const { useGetDeliveryConfigQuery, useFetchDeliveryQuoteMutation } = deliveryApi;
